import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98497bfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pa-4" }
const _hoisted_2 = { class: "text-h5 font-weight-bold titulo" }
const _hoisted_3 = { class: "text-body-2 text-medium-emphasis mt-1 mb-0" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = {
  key: 0,
  class: "text-body-2 mb-2"
}
const _hoisted_6 = {
  key: 1,
  class: "d-flex flex-wrap ga-2"
}
const _hoisted_7 = { class: "datos mt-6" }
const _hoisted_8 = { class: "dato" }
const _hoisted_9 = {
  key: 0,
  class: "dato"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Lugar", -1))
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "dato" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Precio", -1))
const _hoisted_14 = { class: "dato" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Plazas", -1))
const _hoisted_16 = { class: "dato" }
const _hoisted_17 = { class: "dato" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Inscripción", -1))
const _hoisted_19 = { class: "dato" }
const _hoisted_20 = {
  key: 1,
  class: "dato"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Contacto", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle-2 text-medium-emphasis mt-6 mb-1" }, "Descripción", -1))
const _hoisted_23 = { class: "text-body-2 descripcion" }
const _hoisted_24 = { class: "pa-3" }
const _hoisted_25 = { class: "text-caption text-medium-emphasis mb-2" }
const _hoisted_26 = {
  key: 0,
  class: "text-center text-medium-emphasis pa-6"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  class: "text-center text-medium-emphasis pa-6"
}
const _hoisted_29 = { class: "font-weight-bold text-truncate me-2" }
const _hoisted_30 = { class: "text-caption text-medium-emphasis flex-shrink-0" }
const _hoisted_31 = ["onClick"]

import { ref, onMounted, watch, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Torneo } from "@/interfaces/Torneo";
import {
  descargarBasesTorneo,
  getEquiposByTorneoAsync,
  getTorneo,
} from "@/services/TorneosService";
import {
  estaApuntadoTorneoAsync,
  getInscripcionesIndividualByUser,
  getInscripcionesTorneo,
  registrarInscripcion,
  cancelarInscripcion,
  eliminarEquipoAsync,
} from "@/services/InscripcionesService";
import { useAuth } from "@/composables/useAuth";
import {
  CrearInscripcionDTO,
  EquipoDTO,
  InscripcionUsuarioIndividualDTO,
} from "@/interfaces/Inscripcion";
import ModalError from "@/components/Commons/ModalError.vue";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import ModalConfirmarInscripcion from "@/components/Inscripcion/ModalConfirmarInscripcion.vue";
import { esPorJornadas, nombreEvento, textosEvento } from "@/Constant/FormatoTorneo";
import { esUsuarioBye } from "@/utils/bye";
import { tipoTorneoOptions } from "@/Constant/TiposTorneo";
import ModalInscripcion from "@/components/Inscripcion/ModalInscripcion.vue";
import LoadingGandalf from "@/components/Commons/LoadingGandalf.vue";
import { diaDeHoy, formatHora, ultimoDiaEvento } from "@/utils/Fecha";
import ModalRegistroEquipo from "@/components/Inscripcion/ModalRegistroEquipo.vue";
import DetalleTorneoLiveView from "@/views/DetalleTorneoLiveView.vue";
import DetalleTorneoLiveMasView from "@/views/DetalleTorneoLiveMasView.vue";
import DetalleTorneoLiveEquiposView from "@/views/DetalleTorneoLiveEquiposView.vue";
import { entregarArchivos } from "@/utils/entregarArchivos";

interface AccionEstado {
  texto: string;
  hacer: () => void;
  color?: string;
  variant?: "flat" | "tonal" | "text" | "outlined";
  block?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DetalleTorneoView',
  setup(__props) {

const { getidUsuario } = useAuth();
const route = useRoute();
const router = useRouter();
const idTorneo = ref<number>(parseInt(route.params.idTorneo as string));

const torneo = ref<Torneo>();
// Liga y Copa comparten ficha: jornadas, ejército fijo y sin horario
const esLiga = computed(() => esPorJornadas(torneo.value?.formatoTorneo));
const participantes = ref<InscripcionUsuarioIndividualDTO[]>([]);
const idUsuario = ref<string | null>(getidUsuario.value);
const estaApuntado = ref<boolean>(false);
const idInscripcion = ref<number>(0);
const idEquipo = ref<number | undefined>(undefined);

const torneosApuntado = ref<InscripcionUsuarioIndividualDTO[]>();

const tab = ref<string>("detalle");
const search = ref<string | null>("");
const tipoTorneo = ref<string>("");

const isLoading = ref<boolean>(true);
const showSuccessModal = ref<boolean>(false);
const messageSuccess = ref<string>("");
const showErrorModal = ref<boolean>(false);
const isRegistering = ref<boolean>(false);
const showModalInscripcionPorEquipos = ref<boolean>(false);

const infoEquipos = ref<EquipoDTO[]>([]);

const porEquipos = computed(() => !!torneo.value && torneo.value.tipoTorneo !== "Individual");
const esParejas = computed(() => torneo.value?.tipoTorneo === "Parejas");
const textoBorrarEquipo = computed(() => (esParejas.value ? "¿Borrar tu pareja?" : "¿Borrar tu equipo?"));

// Computado para determinar si el usuario es el capitán
const isCapitan = computed(() => {
  const equipoCapitan = infoEquipos.value.find(
    equipo =>
      equipo.idCapitan ===
      (idUsuario.value ? parseInt(idUsuario.value) : undefined)
  );
  return equipoCapitan !== undefined;
});

// Watch para actualizar el idEquipo cuando se encuentra el capitán
watch([infoEquipos, idUsuario], () => {
  const equipoCapitan = infoEquipos.value.find(
    equipo =>
      equipo.idCapitan ===
      (idUsuario.value ? parseInt(idUsuario.value) : undefined)
  );

  if (equipoCapitan) {
    idEquipo.value = equipoCapitan.idEquipo;
  } else {
    idEquipo.value = undefined;
  }
});

// Variables reactivas
const formattedAddress = ref<string>("");

// Computed property para generar el enlace a Google Maps
const googleMapsUrl = computed(() => {
  if (!torneo.value?.lugarTorneo || !isValidCoordinates(torneo.value.lugarTorneo)) return "";
  return `https://www.google.com/maps?q=${parseFloat(
    torneo.value.lugarTorneo.split(", ")[0]
  )},${parseFloat(torneo.value.lugarTorneo.split(", ")[1])}`;
});

// Función para obtener dirección inversa desde coordenadas
const getAddress = async (lat: number, lon: number) => {
  const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`;
  try {
    const response = await fetch(url);
    const data = await response.json();

    if (data.address) {
      const { road, house_number, city, town, village, state, postcode } =
        data.address;

      // Priorizar ciudad, pueblo o aldea
      const locationCity = city || town || village || "";

      // Construir dirección formateada
      formattedAddress.value = [
        road ? `${road}${house_number ? `, ${house_number}` : ""}` : "",
        locationCity,
        state,
        postcode,
      ]
        .filter(Boolean) // Eliminar valores vacíos
        .join(", "); // Unir con comas
    } else {
      formattedAddress.value = "Dirección no disponible";
    }
  } catch (error) {
    console.error("Error obteniendo la dirección:", error);
  }
};
const isValidCoordinates = (value: string): boolean => {
  if (!value) return false;

  // Expresión regular para validar coordenadas (lat, lng)
  const regex = /^-?\d{1,2}\.\d+,\s*-?\d{1,3}\.\d+$/;

  return regex.test(value.trim());
};

// Computed para verificar si el plazo de inscripción está cerrado
const isInscripcionCerrada = computed(() => {
  if (
    !torneo.value ||
    !torneo.value.fechaFinInscripcion ||
    !torneo.value.inicioInscripciones
  )
    return false;
  // Por días: el último día del plazo aún se puede inscribir (comparar con la hora lo cerraba a medianoche)
  const hoy = diaDeHoy();
  return (
    hoy > torneo.value.fechaFinInscripcion.slice(0, 10) ||
    hoy < torneo.value.inicioInscripciones.slice(0, 10)
  );
});

// Disputado cuando ya pasó su último día: el mismo día del evento todavía no
const yaDisputado = computed(
  () =>
    !!torneo.value &&
    ultimoDiaEvento(torneo.value.fechaInicioTorneo, torneo.value.fechaFinTorneo) < diaDeHoy()
);

const goToUserDetail = (idUsuario: number) => {
  router.push({ name: "detalle-jugador", params: { idUsuario: idUsuario } });
};
// const goToEquipoDetail = (idEquipo: number) => {
//   //TODO: modal con la info (nick) de los jugadores que se pueda pulsar en ellos y te lleven a su perfil
// };

const eliminarInscripcion = async (idInscripcion: number) => {
  isRegistering.value = true;
  try {
    const response = await cancelarInscripcion(idInscripcion);

    if (response.request?.status === 200) {
      messageSuccess.value = "Te has borrado con éxito.";
      showSuccessModal.value = true;
    } else {
      showErrorModal.value = true;
    }
  } catch {
    isRegistering.value = false;
    showErrorModal.value = true;
  } finally {
    isRegistering.value = false;
  }
};

const eliminarInscripcionEquipo = async (
  idEquipo: number | null | undefined
) => {
  isRegistering.value = true;
  if (!idEquipo) {
    showErrorModal.value = true;
    return;
  }
  try {
    const response = await eliminarEquipoAsync(idEquipo);

    if (response.request?.status === 200) {
      messageSuccess.value = "Equipo eliminado con exito.";
      showSuccessModal.value = true;
    } else {
      showErrorModal.value = true;
    }
  } catch {
    isRegistering.value = false;
    showErrorModal.value = true;
  } finally {
    isRegistering.value = false;
  }
};

// Montaje y obtención de datos
onMounted(async () => {
  isLoading.value = true;
  try {
    if (idUsuario.value != null) {
      idTorneo.value = Number(route.params.idTorneo);

      //TODO Cambiar getInscripcionesUser por servicio que devuelva el estado de la inscripción al torneo.
      // No es necesario tener una lista de inscripciones, es mas optimo solo la inscripción al torneo.
      // Paralelizar las solicitudes
      const [responseTorneo, responseInscripcion, responseInscriptionesUser] =
        await Promise.all([
          getTorneo(idTorneo.value),
          getInscripcionesTorneo(idTorneo.value),
          getInscripcionesIndividualByUser(idUsuario.value),
        ]);

      torneo.value = responseTorneo.data;
      participantes.value = responseInscripcion.data;
      torneosApuntado.value = responseInscriptionesUser.data;

      // Verificar si el usuario ya está apuntado
      if (torneosApuntado.value != null) {
        torneosApuntado.value.forEach(element => {
          if (element.idTorneo === idTorneo.value) {
            idInscripcion.value = element.idInscripcion;
            estaApuntado.value = true;
            if (element.idEquipo != null) idEquipo.value = element.idEquipo;
          }
        });

      }
    }

    if (torneo.value) tipoTorneo.value = torneo.value.tipoTorneo;
    const pedida = String(route.query.tab ?? "");
    if (PESTANAS.includes(pedida)) tab.value = pedida;
    else if (haEmpezado.value) tab.value = "resultados";

    if (idTorneo.value) {
      const responseEquipos = await getEquiposByTorneoAsync(idTorneo.value);

      infoEquipos.value = responseEquipos.data;
    }
    try {
      if (torneo.value)
        if (isValidCoordinates(torneo.value.lugarTorneo)) {
          getAddress(
            parseFloat(torneo.value.lugarTorneo.split(", ")[0]),
            parseFloat(torneo.value.lugarTorneo.split(", ")[1])
          );
        }
    } catch (err) {
      console.error("Error al obtener coordenadas del torneo:", err);
    }
    if (idTorneo.value && idUsuario.value) {
      const responseEstaApuntado = await estaApuntadoTorneoAsync(
        idTorneo.value,
        parseInt(idUsuario.value)
      );

      if (responseEstaApuntado.data) estaApuntado.value = true;
    }
  } catch (err) {
    console.error("Error al cargar el torneo:", err);
  } finally {
    isLoading.value = false;
  }
});

watch(
  () => showSuccessModal.value,
  newValue => {
    if (!newValue) {
      router.push({ name: "mis-torneos", params: { tab: "three" } });
    }
  }
);

// "AAAA-MM-DD…" del back como fecha local: con new Date(texto) sería medianoche UTC
const aFecha = (fecha?: string | null) => {
  const [anio, mes, dia] = (fecha ?? "").slice(0, 10).split("-").map(Number);
  return anio ? new Date(anio, mes - 1, dia) : null;
};
// «12 dic 2026»
const fechaCorta = (fecha?: string | null) =>
  aFecha(fecha)?.toLocaleDateString("es-ES", { day: "numeric", month: "short", year: "numeric" }) ?? "—";
// «Sáb, 12 dic 2026»: con el día de la semana, que es lo primero que se mira
const fechaLarga = (fecha?: string | null) => {
  const texto = aFecha(fecha)?.toLocaleDateString("es-ES", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  });
  return texto ? texto.charAt(0).toUpperCase() + texto.slice(1) : "—";
};

const fechaEvento = computed(() => {
  const t = torneo.value;
  if (!t) return "";
  const fin = ultimoDiaEvento(t.fechaInicioTorneo, t.fechaFinTorneo);
  if (esLiga.value || fin > t.fechaInicioTorneo.slice(0, 10))
    return `Del ${fechaCorta(t.fechaInicioTorneo)} al ${fechaCorta(fin)}`;
  const hora = formatHora(t.horaInicioTorneo);
  return hora && hora !== "00:00" ? `${fechaLarga(t.fechaInicioTorneo)} · ${hora}` : fechaLarga(t.fechaInicioTorneo);
});

// «Torneo · Individual · 700 puntos»; en liga y copa, también ida y vuelta y ELO
const resumen = computed(() => {
  const t = torneo.value;
  if (!t) return "";
  const tipo = tipoTorneoOptions.find(o => o.value === t.tipoTorneo)?.label ?? t.tipoTorneo;
  const partes = [nombreEvento(t.formatoTorneo), tipo, `${t.puntosTorneo} puntos`];
  if (esLiga.value) partes.push(t.idaYVuelta ? "Ida y vuelta" : "Solo ida", t.cuentaElo ? "Cuenta para el ELO" : "Sin ELO");
  return partes.join(" · ");
});

// La dirección legible; si no hay coordenadas, el texto tal cual
const lugar = computed(() => formattedAddress.value.trim() || (isValidCoordinates(torneo.value?.lugarTorneo ?? "") ? "" : torneo.value?.lugarTorneo ?? ""));

// El bye no es nadie: ni ocupa plaza ni sale en inscritos
const participantesReales = computed(() => participantes.value.filter(p => !esUsuarioBye(p.idUsuario, p.nick)));
const equiposReales = computed(() => infoEquipos.value.filter(e => !esUsuarioBye(e.idCapitan, e.nombreEquipo)));

// En los eventos por equipos o parejas, el límite es de equipos o parejas, como cuenta la gestión del organizador
const plazasOcupadas = computed(() =>
  porEquipos.value ? equiposReales.value.length : participantesReales.value.length
);
const torneoCompleto = computed(
  () => !!torneo.value?.limiteParticipantes && plazasOcupadas.value >= torneo.value.limiteParticipantes
);

const normalizar = (texto: string) => texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
const texto = computed(() => normalizar((search.value ?? "").trim()));
const porNick = (a: { nick?: string | null }, b: { nick?: string | null }) =>
  (a.nick ?? "").localeCompare(b.nick ?? "", "es", { sensitivity: "base" });

const inscritosVisibles = computed(() =>
  [...participantesReales.value].filter(p => normalizar(p.nick ?? "").includes(texto.value)).sort(porNick)
);

const equiposVisibles = computed(() =>
  equiposReales.value
    .map(e => {
      const nombre = e.nombreEquipo ?? "Equipo";
      const coincideEquipo = normalizar(nombre).includes(texto.value);
      return {
        nombre,
        total: e.inscripciones.length,
        jugadores: [...e.inscripciones]
          .filter(i => coincideEquipo || normalizar(i.nick ?? "").includes(texto.value))
          .sort(porNick),
      };
    })
    .filter(e => e.jugadores.length > 0)
    .sort((a, b) => a.nombre.localeCompare(b.nombre, "es", { sensitivity: "base" }))
);

// Al buscar se abren los equipos que coinciden
const equiposAbiertos = ref<string[]>([]);
watch(texto, () => {
  equiposAbiertos.value = texto.value ? equiposVisibles.value.map(e => e.nombre) : [];
});

// «45 jugadores» o «20 equipos»
const resumenInscritos = computed(() => {
  if (!porEquipos.value) {
    const n = participantesReales.value.length;
    return `${n} ${n === 1 ? "jugador" : "jugadores"}`;
  }
  const n = equiposReales.value.length;
  if (esParejas.value) return `${n} ${n === 1 ? "pareja" : "parejas"}`;
  return `${n} ${n === 1 ? "equipo" : "equipos"}`;
});

const textoVacio = computed(() => (texto.value ? "Nada coincide con la búsqueda." : "Todavía no hay inscritos."));

// La vista en vivo que toca: la individual también lleva la liga y la copa
const vistaResultados = computed(() => {
  const t = torneo.value;
  if (!t || esPorJornadas(t.formatoTorneo)) return DetalleTorneoLiveView;
  if (t.tipoTorneo !== "Individual") return DetalleTorneoLiveEquiposView;
  return t.listasPorJugador > 1 ? DetalleTorneoLiveMasView : DetalleTorneoLiveView;
});

// La pestaña va en la URL (?tab=resultados): Mis eventos enlaza directo a los resultados y al recargar se queda
const PESTANAS = ["detalle", "inscritos", "resultados"];
watch(tab, valor => {
  if (route.query.tab !== valor) router.replace({ query: { ...route.query, tab: valor } });
});

// Tu situación y lo que puedes hacer, justo bajo el nombre
const haEmpezado = computed(() => !!torneo.value && torneo.value.fechaInicioTorneo.slice(0, 10) <= diaDeHoy());

const estado = computed<{ texto: string; acciones: AccionEstado[] }>(() => {
  const t = torneo.value;
  if (!t) return { texto: "", acciones: [] };
  const resultados: AccionEstado = { texto: "Resultados", hacer: goToResultados };
  if (yaDisputado.value) return { texto: "Ya se ha jugado.", acciones: [resultados] };

  const acciones: AccionEstado[] = [];
  let texto = "";
  if (estaApuntado.value) {
    texto = porEquipos.value ? (esParejas.value ? "Tu pareja está inscrita." : "Tu equipo está inscrito.") : "Estás inscrito.";
    acciones.push({ texto: "Mi inscripción", hacer: verMiInscripcion });
    if (isInscripcionCerrada.value) texto += " Las inscripciones están cerradas: ya no se puede borrar.";
    else if (!porEquipos.value || isCapitan.value)
      acciones.push({ texto: "Borrar inscripción", color: "error", variant: "text", hacer: () => (showConfirmarBorrar.value = true) });
    else texto += " Solo el capitán puede borrar la inscripción.";
  } else if (isInscripcionCerrada.value) {
    texto =
      t.inicioInscripciones && diaDeHoy() < t.inicioInscripciones.slice(0, 10)
        ? `Las inscripciones abren el ${fechaCorta(t.inicioInscripciones)}.`
        : "Inscripción cerrada.";
  } else if (torneoCompleto.value) {
    texto = "Plazas agotadas.";
  } else {
    acciones.push({
      texto: porEquipos.value ? (esParejas.value ? "Apuntar pareja" : "Apuntar equipo") : "Apúntate",
      variant: "flat",
      block: true,
      hacer: porEquipos.value ? inscripcionPorEquipos : inscripcionIndividual,
    });
  }
  if (haEmpezado.value) acciones.push(resultados);
  return { texto, acciones };
});

const goToResultados = () => {
  tab.value = "resultados";
};

// La inscripción individual, en la misma ventana que en Mis eventos; la de equipo se gestiona allí
const showMiInscripcion = ref(false);
const miInscripcion = computed(() => torneosApuntado.value?.find(i => i.idTorneo === idTorneo.value));
const verMiInscripcion = () => {
  if (porEquipos.value || !miInscripcion.value) router.push({ name: "mis-torneos" });
  else showMiInscripcion.value = true;
};

const showConfirmarBorrar = ref(false);
const confirmarBorrar = async () => {
  showConfirmarBorrar.value = false;
  showMiInscripcion.value = false;
  if (porEquipos.value) await eliminarInscripcionEquipo(idEquipo.value);
  else await eliminarInscripcion(idInscripcion.value);
};

// En un móvil el PDF puede tardar: sin esto no se ve nada y se vuelve a pulsar
const descargandoBases = ref<boolean>(false);

const descargarBases = async () => {
  descargandoBases.value = true;
  try {
    if (idTorneo.value) {
      const response = await descargarBasesTorneo(idTorneo.value);
      await entregarArchivos([
        {
          blob: response.data,
          nombre: `Bases_Torneo_${torneo.value?.nombreTorneo}.pdf`,
        },
      ]);
    }
  } catch (error) {
    console.error("Error descargando el archivo:", error);
    alert("Error al descargar el archivo. Por favor, inténtelo de nuevo.");
  } finally {
    descargandoBases.value = false;
  }
};

const showConfirmarInscripcion = ref<boolean>(false);
// En liga y copa el ejército de todo el evento se elige al inscribirse
const pedirEjercito = computed(() => esPorJornadas(torneo.value?.formatoTorneo));

const inscripcionIndividual = async () => {
  if (idInscripcion.value == 0) {
    showConfirmarInscripcion.value = true;
    return;
  }
  await registrarIndividual();
};

const registrarIndividual = async (datos?: { ejercito: string | null; compartirEmail: boolean }) => {
  isRegistering.value = true;

  if (
    idUsuario.value != null &&
    idTorneo.value != null &&
    !isInscripcionCerrada.value &&
    idInscripcion.value == 0
  ) {
    const inscripcion: CrearInscripcionDTO = {
      idUsuario: parseInt(idUsuario.value),
      idTorneo: idTorneo.value,
      ejercitoElegido: datos?.ejercito ?? undefined,
      compartirEmail: datos?.compartirEmail ?? null,
    };
    try {
      await registrarInscripcion(inscripcion);
      messageSuccess.value = "Te has registrado con éxito.";
      showSuccessModal.value = true;
    } catch (error) {
      isRegistering.value = false;
      showErrorModal.value = true;
    } finally {
      isRegistering.value = false;
    }
  } else {
    eliminarInscripcion(idInscripcion.value);
  }
};

const inscripcionPorEquipos = async () => {
  if (
    idUsuario.value != null &&
    idTorneo.value != 0 &&
    (tipoTorneo.value != "" || tipoTorneo.value != undefined) &&
    !isInscripcionCerrada.value
  ) {
    showModalInscripcionPorEquipos.value = true;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "pa-0 pa-sm-4" }, {
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createBlock(LoadingGandalf, { key: 0 }))
        : (torneo.value)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 1,
              flat: "",
              class: _normalizeClass(["detalle mx-auto", { 'detalle--ancha': tab.value === 'resultados' }])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tabs, {
                  modelValue: tab.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
                  grow: "",
                  class: "pestanas-evento"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tab, { value: "detalle" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Detalle")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, { value: "inscritos" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Inscritos")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, { value: "resultados" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Resultados")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_window, {
                  modelValue: tab.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((tab).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window_item, { value: "detalle" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          src: torneo.value.cartelTorneo || require('@/assets/images/cartelMissing.jpg'),
                          height: "260",
                          class: "cartel"
                        }, null, 8, ["src"]),
                        _createElementVNode("div", _hoisted_1, [
                          _createElementVNode("h1", _hoisted_2, _toDisplayString(torneo.value.nombreTorneo), 1),
                          _createElementVNode("p", _hoisted_3, _toDisplayString(resumen.value), 1),
                          _createElementVNode("div", _hoisted_4, [
                            (estado.value.texto)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(estado.value.texto), 1))
                              : _createCommentVNode("", true),
                            (estado.value.acciones.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(estado.value.acciones, (accion) => {
                                    return (_openBlock(), _createBlock(_component_v_btn, {
                                      key: accion.texto,
                                      color: accion.color ?? 'primary',
                                      variant: accion.variant ?? 'tonal',
                                      block: accion.block,
                                      class: "text-none",
                                      onClick: accion.hacer
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(accion.texto), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["color", "variant", "block", "onClick"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("dl", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("dt", null, _toDisplayString(esLiga.value ? "Fechas" : "Fecha"), 1),
                              _createElementVNode("dd", null, _toDisplayString(fechaEvento.value), 1)
                            ]),
                            (lugar.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  _hoisted_10,
                                  _createElementVNode("dd", null, [
                                    (googleMapsUrl.value)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          href: googleMapsUrl.value,
                                          target: "_blank",
                                          rel: "noopener noreferrer"
                                        }, _toDisplayString(lugar.value), 9, _hoisted_11))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(_toDisplayString(lugar.value), 1)
                                        ], 64))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_12, [
                              _hoisted_13,
                              _createElementVNode("dd", null, _toDisplayString(torneo.value.precioTorneo) + " €", 1)
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _hoisted_15,
                              _createElementVNode("dd", null, [
                                _createTextVNode(_toDisplayString(plazasOcupadas.value) + " / " + _toDisplayString(torneo.value.limiteParticipantes || "sin límite") + " ", 1),
                                (porEquipos.value && torneo.value.limiteParticipantes)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(esParejas.value ? "parejas" : "equipos"), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("dt", null, _toDisplayString(esLiga.value ? "Jornadas" : "Partidas"), 1),
                              _createElementVNode("dd", null, _toDisplayString(esLiga.value && torneo.value.numeroPartidas <= 1 ? "al cerrar las inscripciones" : torneo.value.numeroPartidas), 1)
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _hoisted_18,
                              _createElementVNode("dd", null, "del " + _toDisplayString(fechaCorta(torneo.value.inicioInscripciones)) + " al " + _toDisplayString(fechaCorta(torneo.value.fechaFinInscripcion)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("dt", null, _toDisplayString(esLiga.value ? "Primera lista" : "Listas"), 1),
                              _createElementVNode("dd", null, "hasta el " + _toDisplayString(fechaCorta(torneo.value.fechaEntregaListas)), 1)
                            ]),
                            (torneo.value.contacto)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _hoisted_21,
                                  _createElementVNode("dd", null, _toDisplayString(torneo.value.contacto), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (torneo.value.descripcionTorneo?.trim())
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _hoisted_22,
                                _createElementVNode("p", _hoisted_23, _toDisplayString(torneo.value.descripcionTorneo), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (torneo.value.tieneBases)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 1,
                                variant: "outlined",
                                block: "",
                                class: "mt-6 text-none",
                                loading: descargandoBases.value,
                                onClick: descargarBases
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Descargar bases ")
                                ]),
                                _: 1
                              }, 8, ["loading"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, { value: "inscritos" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("p", _hoisted_25, _toDisplayString(resumenInscritos.value), 1),
                          _createVNode(_component_v_text_field, {
                            modelValue: search.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
                            placeholder: porEquipos.value ? 'Buscar equipo o jugador' : 'Buscar jugador',
                            variant: "outlined",
                            density: "compact",
                            "hide-details": "",
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _createVNode(_component_v_divider),
                        (!porEquipos.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (inscritosVisibles.value.length === 0)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(textoVacio.value), 1))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inscritosVisibles.value, (inscrito) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: inscrito.idUsuario,
                                  class: "fila px-3 py-2"
                                }, [
                                  _createElementVNode("a", {
                                    class: "nick",
                                    role: "link",
                                    tabindex: "0",
                                    onClick: ($event: any) => (goToUserDetail(inscrito.idUsuario))
                                  }, _toDisplayString(inscrito.nick), 9, _hoisted_27)
                                ]))
                              }), 128))
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (equiposVisibles.value.length === 0)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(textoVacio.value), 1))
                                : (_openBlock(), _createBlock(_component_v_expansion_panels, {
                                    key: 1,
                                    modelValue: equiposAbiertos.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((equiposAbiertos).value = $event)),
                                    multiple: "",
                                    variant: "accordion"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(equiposVisibles.value, (equipo) => {
                                        return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                                          key: equipo.nombre,
                                          value: equipo.nombre
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_expansion_panel_title, null, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_29, _toDisplayString(equipo.nombre), 1),
                                                _createElementVNode("span", _hoisted_30, _toDisplayString(equipo.total) + " " + _toDisplayString(equipo.total === 1 ? "jugador" : "jugadores"), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_expansion_panel_text, { class: "panel-equipo" }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(equipo.jugadores, (jugador) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: jugador.idUsuario,
                                                    class: "fila px-3 py-2"
                                                  }, [
                                                    _createElementVNode("a", {
                                                      class: "nick nick--jugador",
                                                      role: "link",
                                                      tabindex: "0",
                                                      onClick: ($event: any) => (goToUserDetail(jugador.idUsuario))
                                                    }, _toDisplayString(jugador.nick), 9, _hoisted_31)
                                                  ]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                            ], 64))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, { value: "resultados" }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(vistaResultados.value)))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
      _createVNode(_component_v_dialog, {
        modelValue: showConfirmarBorrar.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showConfirmarBorrar).value = $event)),
        "max-width": "420"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-wrap" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(porEquipos.value ? textoBorrarEquipo.value : "¿Borrar tu inscripción?"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createTextVNode("Dejarás de estar en " + _toDisplayString(_unref(textosEvento)(torneo.value?.formatoTorneo).el) + ". Puedes volver a apuntarte mientras siga abierto.", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    color: "grey",
                    variant: "text",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (showConfirmarBorrar.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cancelar")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: "error",
                    variant: "tonal",
                    onClick: confirmarBorrar
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Borrar")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (showMiInscripcion.value && miInscripcion.value)
        ? (_openBlock(), _createBlock(ModalInscripcion, {
            key: 2,
            idInscripcion: miInscripcion.value.idInscripcion,
            idUsuario: Number(idUsuario.value),
            idTorneo: idTorneo.value,
            idOrganizador: torneo.value?.idUsuario ?? 0,
            ejercitoElegido: miInscripcion.value.ejercitoElegido ?? null,
            onEliminarInscripcion: _cache[6] || (_cache[6] = ($event: any) => (showConfirmarBorrar.value = true)),
            onClose: _cache[7] || (_cache[7] = ($event: any) => (showMiInscripcion.value = false))
          }, null, 8, ["idInscripcion", "idUsuario", "idTorneo", "idOrganizador", "ejercitoElegido"]))
        : _createCommentVNode("", true),
      _createVNode(ModalRegistroEquipo, {
        isVisible: showModalInscripcionPorEquipos.value,
        tipoTorneo: torneo.value?.tipoTorneo,
        idTorneo: idTorneo.value,
        "onUpdate:isVisible": _cache[8] || (_cache[8] = ($event: any) => (showModalInscripcionPorEquipos.value = $event))
      }, null, 8, ["isVisible", "tipoTorneo", "idTorneo"]),
      _createVNode(ModalConfirmarInscripcion, {
        isVisible: showConfirmarInscripcion.value,
        titulo: pedirEjercito.value ? `¿Con qué ejército juegas ${_unref(textosEvento)(torneo.value?.formatoTorneo).el}?` : `Inscribirte en ${_unref(textosEvento)(torneo.value?.formatoTorneo).el}`,
        pedirEjercito: pedirEjercito.value,
        "onUpdate:isVisible": _cache[9] || (_cache[9] = ($event: any) => (showConfirmarInscripcion.value = $event)),
        onConfirm: registrarIndividual
      }, null, 8, ["isVisible", "titulo", "pedirEjercito"]),
      _createVNode(ModalSuccess, {
        isVisible: showSuccessModal.value,
        message: messageSuccess.value,
        "onUpdate:isVisible": _cache[10] || (_cache[10] = ($event: any) => (showSuccessModal.value = $event))
      }, null, 8, ["isVisible", "message"]),
      _createVNode(ModalError, {
        isVisible: showErrorModal.value,
        message: "No se ha podido registrar la inscripción. Contacta con el administrador.",
        "onUpdate:isVisible": _cache[11] || (_cache[11] = ($event: any) => (showErrorModal.value = $event))
      }, null, 8, ["isVisible"]),
      _createVNode(_component_v_dialog, {
        modelValue: isRegistering.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((isRegistering).value = $event)),
        persistent: "",
        width: "300"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, {
                class: "d-flex justify-center align-center",
                style: {"height":"150px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    color: "blue-lighten-3",
                    size: 57
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})